export default function ContactSection() {
  return (
    <section id="contato" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">
              Contato
            </span>
            <h2 className="font-serif text-5xl md:text-6xl font-bold text-[#0f2651] mt-3 mb-5 leading-tight">
              Pronto para transformar<span className="text-[#c9a84c]"> sua empresa?</span>
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-8">
              Se sua empresa precisa de mais controle, menos risco e melhores resultados, a RCP está
              pronta para ajudar. Solicite agora seu diagnóstico inicial — gratuito e sem compromisso.
            </p>

            <div className="space-y-5 mb-10">
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-[#0f2651]/5 rounded-lg text-[#0f2651]">
                  <i className="ri-mail-line text-lg" />
                </div>
                <div>
                  <div className="text-sm text-gray-400 font-medium">E-mail</div>
                  <a
                    href="mailto:contato@rcpinteligencia.com.br"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#0f2651] text-sm font-medium hover:text-[#c9a84c] transition-colors duration-200 cursor-pointer"
                  >
                    contato@rcpinteligencia.com.br
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-[#0f2651]/5 rounded-lg text-[#0f2651]">
                  <i className="ri-whatsapp-line text-lg" />
                </div>
                <div>
                  <div className="text-sm text-gray-400 font-medium">Telefone / WhatsApp</div>
                  <a
                    href="https://wa.me/5551991003410"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#0f2651] text-sm font-medium hover:text-[#c9a84c] transition-colors duration-200 cursor-pointer"
                  >
                    (51) 99100-3410
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-[#0f2651]/5 rounded-lg text-[#0f2651]">
                  <i className="ri-instagram-line text-lg" />
                </div>
                <div>
                  <div className="text-sm text-gray-400 font-medium">Instagram</div>
                  <a
                    href="https://instagram.com/inteligenciarcp"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#0f2651] text-sm font-medium hover:text-[#c9a84c] transition-colors duration-200 cursor-pointer"
                  >
                    @inteligenciarcp
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-[#0f2651]/5 rounded-lg text-[#0f2651]">
                  <i className="ri-map-pin-2-line text-lg" />
                </div>
                <div>
                  <div className="text-sm text-gray-400 font-medium">Localização</div>
                  <a
                    href="https://maps.app.goo.gl/1TcgT68RLkaxy5aL8"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#0f2651] text-sm font-medium hover:text-[#c9a84c] transition-colors duration-200 cursor-pointer"
                  >
                    Porto Alegre, RS — Brasil
                  </a>
                </div>
              </div>
            </div>

            <a
              href="https://wa.me/5551991003410"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#c9a84c] hover:bg-[#b8943d] text-[#0f2651] font-semibold px-8 py-4 rounded-sm text-sm tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base" />
              </div>
              Solicitar Diagnóstico Gratuito
            </a>
          </div>

          <div className="bg-[#f8f6f2] rounded-xl p-10">
            <h4 className="font-serif text-2xl font-bold text-[#0f2651] mb-2">
              O que acontece após o contato?
            </h4>
            <p className="text-gray-400 text-base mb-8">
              Um processo simples, transparente e sem pressão.
            </p>
            <ul className="space-y-6">
              {[
                'Entramos em contato em até 24 horas úteis',
                'Realizamos um diagnóstico inicial gratuito',
                'Apresentamos nossa proposta personalizada',
                'Você decide sem nenhuma pressão',
              ].map((step, idx) => (
                <li key={idx} className="flex items-start gap-5">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#0f2651] text-[#c9a84c] font-bold text-sm flex-shrink-0">
                    {idx + 1}
                  </div>
                  <div className="pt-1.5">
                    <span className="text-[#0f2651] text-base font-medium">{step}</span>
                  </div>
                </li>
              ))}
            </ul>
            <div className="mt-10 pt-8 border-t border-gray-200 flex items-center gap-3 text-gray-400 text-xs">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-lock-line text-sm" />
              </div>
              Seus dados estão seguros. Sem spam, sem compromisso.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
